import { Link } from "react-router-dom";

function Header() {
  return (
    <>
      <section className=" col-12 bg-light bg-gradient" id="rapid-home">
        {/* <!-- contact details --> */}
        <div className=" contact-bg px-0 w-100 d-lg-flex justify-content-lg-around flex-lg-row  col-md-2   d-sm-flex flex-sm-column col-md-5 pt-lg-1 text-center fw-semibold pt-2 ">
          <div className="">
            <p className=" fw-semibold text-center  text-light">
              Community 9, Opposite Tema General Hospital
            </p>
          </div>
          <div>
            <p className="text-light">+233 55 066 2915 / +233 20 592 5509</p>
          </div>
          <div className="">
            <p className="container text-light d-none d-sm-block">
              rapidlabdiagnostics@gmail.com / info@rapidlabdiagnotics.com
            </p>
          </div>
        </div>
        {/* <!-- Headers --> */}
        <nav className="navbar navbar-expand-lg navbar-light   px-lg-3 px-sm-2  ">
          {" "}
          <img
            loading="lazy"
            width="180"
            height="180"
            src="images/assets/rapidLablogo.png "
            alt="rapidLabLogo"
          />
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNavAltMarkup"
            aria-controls="navbarNavAltMarkup"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div
            className=" collapse navbar-collapse  d-lg-flex justify-content-end  "
            id="navbarNavAltMarkup"
          >
            <div className="navbar-nav d-sm-flex align-items-center px-2 fs-6 fw-semibold gap-lg-5">
              <Link
                className="text-primary-emphasis btn-hover-underline "
                to="/"
              >
                Home
              </Link>
              <Link
                className="text-primary-emphasis btn-hover-underline"
                to="/about-us"
              >
                About Us
              </Link>
              <Link
                className="text-primary-emphasis btn-hover-underline"
                to="/services"
              >
                Services
              </Link>
              <Link
                className="text-primary-emphasis btn-hover-underline"
                to="/packages"
              >
                Packages
              </Link>

              <Link to="/forms">
                <button
                  type="button"
                  className="btn btn-outline-none fs-6 fw-semibold btn-hover-underline"
                >
                  Contact Us
                </button>
              </Link>
              <div className="gap-5">
                <Link to="/forms">
                  <button
                    type="button"
                    className="btn btn-primary  text-light "
                  >
                    Make An Appointment
                  </button>
                </Link>
              </div>
              {/* <!-- modal --> */}
              <div
                className="modal fade opacity-2 glass-morph"
                id="exampleModal"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-header d-flex justify-content-between">
                      <div>
                        <h5 className="text-center text-primary-emphasis">
                          CONTACT US
                        </h5>

                        <h4
                          className="modal-title text-center"
                          id="exampleModalLabel"
                        >
                          Make an appointment with us
                        </h4>
                      </div>
                      <button
                        type="button"
                        className="close btn btn-outline-secondary "
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body "></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </section>
    </>
  );
}

export default Header;
